import React, { useState } from "react";
import { get } from "lodash";

import Memberships from "./Memberships";
import PaymentDetails from "./PaymentDetails";
import Title from "../../../../components/Title";
import Spacer from "../../../../components/Spacer";
import AsyncGet from "../../../../components/AsyncGet";

import style from "../style.module.css";

export default function ManagePaymentMethod(props) {
    const {
        userProfile = {}
    } = props;

    const planId = get(userProfile, "membership.plan.id", "");
    const [planDetailsFromApi, setPlanDetailsFromApi] = useState({});
    
    return (
        <>
            {
                planId !== "" && (
                    <AsyncGet
                        url={`/membership/${planId}`}
                        permissionText={false}
                        loadOnMount={true}
                        render={({ data }) => {
                            if(data) {
                                setPlanDetailsFromApi(data);
                            }
                        }}
                    />
                )
            }
            <Spacer size="65" />
            <div className={`${style.colRow} ${style.sectionItem}`}>
                <div className={style.titleContent}>
                    <Title className="fontTeko" transform="uppercase" tag="h4">MEMBERSHIP  details</Title>
                </div>
                <div className={style.formContent}>
                    <Memberships
                        planDetailsFromApi={planDetailsFromApi}
                        userProfile={userProfile}
                    />
                    {
                        get(userProfile, 'membership.type', '') !== "free" && (
                            <>
                                <div className={style.cardItem}>
                                    <div className={style.cardItemtBody}>
                                        <PaymentDetails
                                            userProfile={userProfile}
                                        />
                                    </div>
                                </div>
                                <Spacer size="65" />
                            </>
                        )
                    }
                </div>
            </div>
        </>
    )
}